import React from "react";

import { Box, Button, ThemeProvider, Typography } from "@mui/material";
import ReactDOM from "react-dom/client";

import { theme } from "./styles/theme";
import "./styles/index.css";

function showStartupError() {
  ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
    <ThemeProvider theme={theme}>
      <Box component='main' sx={{ maxWidth: 600, mx: "auto", p: 4 }}>
        <Typography component='h1' variant='h4'>
          LabShare could not load
        </Typography>
        <Typography role='alert' sx={{ my: 2 }}>
          Please reload the page to try again.
        </Typography>
        <Button variant='contained' onClick={() => window.location.reload()}>
          Reload
        </Button>
      </Box>
    </ThemeProvider>
  );
}
// Defer modules that consume runtime configuration until it has been checked.
if (
  (!window.__APP_CONFIG__ && process.env.NODE_ENV !== "production") ||
  (window.__APP_CONFIG__ &&
    typeof window.__APP_CONFIG__.S3_BUCKET_NAME === "string" &&
    typeof window.__APP_CONFIG__.REACT_APP_SOCKET_URL === "string")
) {
  import("./bootstrap").catch(showStartupError);
} else {
  showStartupError();
}
